import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Home::ToTopButton::Component の Stimulus コントローラ。
// landIeul: 800px スクロールで fadeIn、クリックでトップへスムーススクロール。
const SCROLL_TARGET_OFFSET = 800;

class SiteHomeToTopButtonController extends Controller {
  private handler = () => this.onScroll();

  connect(): void {
    window.addEventListener("scroll", this.handler);
    this.onScroll();
  }

  disconnect(): void {
    window.removeEventListener("scroll", this.handler);
  }

  private onScroll(): void {
    this.element.classList.toggle(
      "style_fadeIn",
      window.pageYOffset > SCROLL_TARGET_OFFSET,
    );
  }

  returnTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

application.register("site--home--to-top-button", SiteHomeToTopButtonController);
